import { compareStrings } from '../../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { getLabelByContentControlLightRuleItemStatus } from '../../../../../../../../utils/uiSettings/contentControl/content-control.values';
import { ContentControlDataProtectionRuleLight } from '../../../../../../../../utils/uiSettings/contentControl/content-control.types';

// sort by column type
export function sortByColumn(
  item1: ContentControlDataProtectionRuleLight,
  item2: ContentControlDataProtectionRuleLight,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.STATUS:
      return compareStrings(
        getLabelByContentControlLightRuleItemStatus(item1.status),
        getLabelByContentControlLightRuleItemStatus(item2.status),
        direction
      );

    case ColumnKeys.NAME:
      return compareStrings(item1.name, item2.name, direction);
  }

  return 0;
}
